const ClockIco2 = () => {
    return (
        <svg
            width="7"
            height="7"
            viewBox="0 0 7 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.5 0C1.5701 0 0 1.5701 0 3.5C0 5.4299 1.5701 7 3.5 7C5.4299 7 7 5.4299 7 3.5C7 1.5701 5.4299 0 3.5 0ZM3.5 6.3C1.95615 6.3 0.7 5.04385 0.7 3.5C0.7 1.95615 1.95615 0.7 3.5 0.7C5.04385 0.7 6.3 1.95615 6.3 3.5C6.3 5.04385 5.04385 6.3 3.5 6.3Z"
                fill="#150865"
            />
            <path
                d="M3.85024 1.75H3.15024V3.6449L4.30279 4.79745L4.79769 4.30255L3.85024 3.3551V1.75Z"
                fill="#150865"
            />
        </svg>
    );
}

export default ClockIco2;
